module.exports = __webpack_public_path__ + "img/custServ1.6aba8bd8.jpg";